import apiClient from './apiClient';
import { setupRequestInterceptor, setupResponseInterceptor } from './interceptors';
import config from '@common/common/config';
import type { ApiResponse } from '../types/response';
import cookies from 'js-cookie';
import { ref } from 'vue';
import { setCookieForDay } from '@common/common/utils';
import Cookies from 'js-cookie';

// 인터셉터 초기화
setupRequestInterceptor();
setupResponseInterceptor();

// 토큰 저장 변수
const token = ref<string | undefined>('');
const tokenApiEndPoint = 'for-easy-test/access-token';
const tokenApiEndPointByUid = 'for-easy-test/access-token-by-UID';

// 현재 URL이 /in-app-view/trend-report?uid= 형태인지 확인하는 함수
function isTrendReportPage() {
    const url = new URL(window.location.href);
    return url.pathname.includes('/in-app-view/trend-report') && url.searchParams.has('uid');
}

// API 요청 함수
async function requestFitplus<T>(
    endpoint: string,
    method: 'get' | 'post' | 'put' | 'delete' | 'patch',
    data?: any,
    tokenOptions?: {
        isAdminToken?: boolean;
    },
) {
    const { isAdminToken = false } = tokenOptions ?? {};
    let aipUrl = `${config.apiBaseUrl}${endpoint}`;

    // 기본적으로 토큰을 쿠키에서 읽음
    token.value = cookies.get('tokenValue');

    let authUrl = '';
    let authParams: any = {};

    const urlParams = new URLSearchParams(window.location.search);
    const uid = urlParams.get('uid');

    // 로컬 개발환경이거나, 토큰이 없을 경우 토큰을 가져옴
    if (!token.value) {
        try {
            if (isAdminToken) {
                // 1. isAdminToken === true
                authUrl = `${config.apiBaseUrl}${tokenApiEndPoint}`;
                authParams = {
                    UID: uid,
                    personNum: '8',
                };
            } else if (isTrendReportPage()) {
                Cookies.remove('tokenValue');
                // 3. isAdminToken === false && trend-report 페이지
                authUrl = `${config.apiBaseUrl}${tokenApiEndPointByUid}`;
                authParams = {
                    UID: uid,
                };
            } else {
                // 2. isAdminToken === false && 다른 페이지
                token.value = cookies.get('tokenValue') || '';
            }

            // 만약 authUrl이 세팅되어 있다면 API 호출
            if (authUrl) {
                const authResponse = await apiClient({
                    url: authUrl,
                    method: 'get',
                    params: authParams,
                });

                token.value = authResponse.data;
                setCookieForDay('tokenValue', token.value || '');
            }
        } catch (error: any) {
            return Promise.reject(error.response?.data as ApiResponse<T>);
        }
    }

    // TODO: 배포 시 로직 수정 필요
    // uid 파라미터가 있는 경우 토큰 삭제 후 갱신
    if (isTrendReportPage()) {
        Cookies.remove('tokenValue');
        // 3. isAdminToken === false && trend-report 페이지
        authUrl = `${config.apiBaseUrl}${tokenApiEndPointByUid}`;
        authParams = {
            UID: uid,
        };
    }

    const options = {
        url: aipUrl,
        method,
        params: method === 'get' ? data : null,
        data: method !== 'get' ? data : null,
        headers: {
            Authorization: `Bearer ${token.value}`,
        },
    };

    return apiClient(options)
        .then(response => response.data as ApiResponse<T>)
        .catch(error => {
            throw error;
        });
}

export { requestFitplus };
